import React from 'react';

import '../../utils/styles/Animation.css';

import AnimationCarousel from '../../components/Animation/AnimationCarousel';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons';

function Animation() {
    return (
        <div className="container">
            <p className="title-3">Animation</p>

            <div className="content">
                <p className="title">Assemblée générale des étudiants (AGE)</p>
                <p className="paragraph">
                    L'Assemblée Générale des Étudiants de l'Université de Namur
                    (AGE) est l'organe officiel de représentation des étudiants.
                    Elle est composée d'un <strong>bureau exécutif</strong> et
                    de deux conseils : le <strong>Conseil Étudiant</strong>, qui
                    gère la représentation politique et les droits des
                    étudiants, et le <strong>Conseil de l'Animation</strong>,
                    qui regroupe les présidents des cercles, régionales et
                    kots-à-projet pour organiser des événements sur le campus.
                    <br /> <br />
                    L'AGE soutient, informe et défend les étudiants, tout en
                    proposant de nombreuses activités extra-académiques. Parmi
                    celles-ci, elle supervise les plus grands événements, tels
                    que le <strong>Bal des Bleus</strong>, la{' '}
                    <strong>Saint-Nicolas</strong>, le{' '}
                    <strong>Grand Quiz de l'UNamur</strong>, la{' '}
                    <strong>Fête de l'Université</strong> et le{' '}
                    <strong>Bal des Busés</strong>.
                    <br /> <br />
                    En plus de son rôle d'animation, l'AGE contribue à
                    conscientiser les étudiants sur des sujets d'actualité tels
                    que l'environnement, la durabilité et la politique.
                </p>
            </div>

            <div className="content">
                <p className="title">Revue des facultés</p>
                <p className="paragraph" style={{'marginBottom': '30px'}}>
                    Les <strong>Revues</strong> sont des événements d'animation
                    culturels et festifs organisés par les étudiants des différentes facultés.
                    Une Revue est un spectacle humoristique lors duquel les étudiants
                    se moquent gentiment des professeurs de leur faculté, et qui combine sketches,
                    parodies, chansons, danses et vidéos, souvent basés sur des événements
                    ou des anecdotes de la vie de leur faculté et de l'actualité.
                    Les étudiants mettent en scène leurs professeurs, leurs cours
                    ou des situations de la vie estudiantine autour d'un thème,
                    différent chaque année, le tout avec une touche d'humour et de satire.
                    <br /> <br />
                    Cet événement est l'occasion pour les étudiants et membres
                    du personnel d'une même faculté de se retrouver le temps
                    d'une soirée dans un cadre convivial, de se détendre et
                    de renforcer l'esprit de groupe au sein de leur faculté.
                    Les revues des facultés recherchent constamment de
                    nouveaux étudiants pour contribuer aux éditions à venir
                    et pour animer leurs activités tout au long de l'année.
                    Que ce soit pour les aspects techniques ou la mise en scène,
                    tous les étudiants intéressés à participer et à s'investir
                    sont les bienvenus.
                </p>
                <AnimationCarousel category='revue' />
            </div>

            <div className="content">
                <p className="title">Assemblée des kots à projet (AKàp)</p>
                <p className="paragraph">
                    L'Assemblée des kots-à-projet, plus communément appelée{' '}
                    <strong>AKàP</strong>, est une instance de l'Assemblée
                    Générale des Étudiants de l'Université de Namur (AGE). Elle
                    représente les kots-à-projet ainsi que les projets sans kot
                    de l'Université de Namur. <br />
                    <br />
                    L'AKàP, dirigée par un comité d'étudiants expérimentés,
                    soutient et coordonne les kots-à-projet en les aidant dans
                    la gestion, la promotion, et l'organisation de leurs
                    activités. Elle organise également des événements importants
                    comme la <strong>Semaine des KàPs</strong>, la{' '}
                    <strong>Foire des KàPs</strong>, et le{' '}
                    <strong>Gala AKàP</strong>. <br />
                    <br />
                    Un kot-à-projet est un groupe d'étudiants vivant ensemble
                    dans un logement communautaire pour mener à bien un projet
                    significatif pour le campus ou la société. L'Université de
                    Namur soutient ces projets financièrement et en assure la
                    promotion. Les kots-à-projet abordent divers thèmes, tels
                    que l'environnement, l'inclusion sociale, le sport, et les
                    activités artistiques. Il est également possible d'en créer
                    de nouveaux.
                </p>
                <div className="animation-links">
                    <a className="button" href="https://www.unamur.be/fr/campus/engagement/kap/">
                        <FontAwesomeIcon icon={faArrowUpRightFromSquare} /> En
                        savoir plus
                    </a>
                </div>
                
                <AnimationCarousel category='akap' />
                
            </div>

            <div className="content">
                <p className="title">Assemblée des cercles (ADC)</p>
                <p className="paragraph">
                    L'Assemblée des Cercles (ADC) est l'organisme qui supervise
                    les <strong>onze cercles</strong> de l'Université de Namur.
                    Elle coordonne l'organisation des événements tels que les
                    Bunkers et la gestion des commandes groupées, assure le bon
                    déroulement des soirées étudiantes, et gère également les
                    activités sportives au sein des cercles.
                    <br />
                    <br />
                    En plus des guindailles et soirées, l'ADC soutient des
                    projets environnementaux et culturels pour les étudiants de
                    toutes les facultés, et favorise la rencontre et
                    l'intégration des étudiants d'une même orientation
                    académique.
                </p>
                
                <div className="animation-links">
                    <a
                        className="circle"
                        href="https://www.facebook.com/AssembleeDesCercles"
                    >
                        <FontAwesomeIcon icon={faFacebookF} size="xl" />
                    </a>
                    <a
                        className="circle"
                        href="https://www.instagram.com/adc_unamur/?hl=fr"
                    >
                        <FontAwesomeIcon icon={faInstagram} size="xl" />
                    </a>
                </div>

                <AnimationCarousel category='adc' />
            </div>

            <div className="content">
                <p className="title">Conseil Inter Régionales (CIR)</p>
                <p className="paragraph">
                    Le Conseil Inter-Régionales (CIR) est le garant du folklore
                    estudiantin namurois et représente l'ensemble de la
                    communauté baptisée du campus. Composé d'étudiants, le CIR
                    supervise et soutient les régionales du campus, en veillant
                    à leur bon fonctionnement et en assurant une communication
                    efficace entre l'université et les différentes régionales.
                    Il est également responsable de l'organisation des
                    bleusailles et collabore avec les régionales pour assurer le
                    bon déroulement des activités liées au baptême.
                    <br />
                    <br />
                    Tout au long de l'année, le CIR organise divers événements,
                    dont son événement phare, « L'Arsenal sous le feu des
                    Régionales », où chaque Régionale présente son comité ainsi
                    que ses traditions culturelles et gastronomiques. À
                    l'Université de Namur, le CIR coordonne les activités de 10
                    régionales : <strong>Binchoise</strong>,{' '}
                    <strong>Brabo</strong>, <strong>BW</strong>,{' '}
                    <strong>Carolo</strong>, <strong>Chimacienne</strong>,{' '}
                    <strong>Destuna</strong>, <strong>Liégeoise</strong>,{' '}
                    <strong>Lux</strong>, <strong>Namuroise</strong> et{' '}
                    <strong>RTM</strong>.
                </p>
                <div className="animation-links">
                    <a
                        className="circle"
                        href="https://www.facebook.com/ConseilInterRegionales"
                    >
                        <FontAwesomeIcon icon={faFacebookF} size="xl" />
                    </a>
                    <a
                        className="circle"
                        href="https://www.instagram.com/cir_namur/?hl=fr"
                    >
                        <FontAwesomeIcon icon={faInstagram} size="xl" />
                    </a>
                </div>

                <AnimationCarousel category='regios' />
            </div>
        </div>
    );
}

export default Animation;
